import * as React from "react"
import PropTypes from "prop-types"

let url_global = process.env.GATSBY_API_URL
let image_url =
  "url(" + url_global + "/uploads/" + "valla_blog_Vr2_0a4ef56338.png" + ")"
const Sliderblog = ({ siteTitle }) => (
  <>
    <div
      className="cambiar_fondo_blog w-full flex flex-col lg:grid grid-cols-2"
      alt="Valla visita nuestro blog"
      title="Valla visita nuestro blog"
      style={{
        backgroundImage: `${image_url}`,
        backgroundSize: "100% 96%",
        backgroundAttachment: "scroll",
        backgroundRepeat: "no-repeat",
        height: "22rem",
        top: "2rem",
        position: "relative",
      }}
      tabIndex="1"
    >
      <div
        tabIndex="1"
        className="centrar_titulo_blog"
        style={{
          position: "relative",
          placeItems: "center",
          display: "grid",
          right: "-4.7rem",
        }}
      >
        <h1
          style={{ position: "relative", paddingTop: "8rem" }}
          className=" tamano_texto_blog text-5xl font-black uppercase"
        >
          <span className="text-green-light">Visita nuestro</span>
          <span className="text-green-default"> blog</span>
        </h1>
        <p
          style={{
            position: "relative",
            width: "19rem",
            left: "7.5rem",
            fontSize: "20px",
            bottom: "3rem",
            textAlign: "right",
          }}
          className="segundo_texto_blog text-poppins-regular color-texto-parrafo"
        >
          {" "}
          y dale un giro positivo a tu vida <b>prácticas sanas</b>
        </p>
      </div>
    </div>

    {/* SEGUNDO CONTENIDO DEL BLOG */}

    {/* asssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss */}
    <div className="cambiar_fondo_blog_dos w-full flex flex-col justify-center">
      <div className="mx-auto mitexto bg-white flex items-center justify-end">
        <div className="inline-grid grid-cols-1">
          <div className="imagen_oculta md:shrink-0">
            <img
              src={
                url_global +
                "/uploads/italy_day1381_e1557307857380_488be050c7.jpg"
              }
              className="w-screen object-cover md:h-full"
            />
            <div className="flex justify-end mr-4"></div>
          </div>
          <div className="p-8 text-center">
            <h1
              style={{ position: "relative", paddingTop: "8rem" }}
              className="tamano_texto_blog text-5xl font-black uppercase"
            >
              <span className="mitexto_color text-green-light">
                Visita nuestro
              </span>
              <span className="mitexto_color text-green-default"> blog</span>
            </h1>
            <p
              style={{
                position: "relative",
                width: "19rem",
                left: "7.5rem",
                fontSize: "20px",
                bottom: "0rem",
                textAlign: "right",
              }}
              className="mitexto_color segundo_texto_blog text-poppins-regular color-texto-parrafo"
            >
              {" "}
              y dale un giro positivo a tu vida <b>prácticas sanas</b>
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* asssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss */}

    {/* FIN DEL CONTENIDO DEL BLOG */}
  </>
)

Sliderblog.propTypes = {
  siteTitle: PropTypes.string,
}

Sliderblog.defaultProps = {
  siteTitle: ``,
}

export default Sliderblog
